import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { PurchaseBundleEntry } from '../../../types';

type CellParams = ICellRendererParams<PurchaseBundleEntry> & {
  plusCallback: (item: PurchaseBundleEntry) => void;
  minusCallback: (item: PurchaseBundleEntry) => void;
};

@Component({
  selector: 'app-stripe-purchase-ui-cart-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './stripe-purchase-ui-cart-actions.component.html',
  styleUrl: './stripe-purchase-ui-cart-actions.component.scss',
})
export class StripePurchaseUiCartActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
